import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '@/utils/error-utils';
import { ResourceNotFoundError } from '@/utils/errors';

export const { HomepageContentNotFoundError } = errorFactory(
  'HomepageContentNotFoundError',
  ResourceNotFoundError
);

/** An error that occurs when the homepage returns null content. */
export type HomepageContentNotFoundError = InstanceTypeOf<
  typeof HomepageContentNotFoundError
>;
